import * as z from 'zod';

export const ListTriggersRequest = z.object({});
export const ListTriggersResponse = z.object({
  triggers: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Unique ID of the custom trigger')
          .min(1)
          .max(100)
          .optional(),
        appId: z
          .string()
          .describe('App ID of the custom trigger provider')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
        name: z
          .string()
          .describe('Custom Trigger display name')
          .min(1)
          .max(200)
          .optional(),
      })
    )
    .max(1000)
    .optional(),
});
